export default "__VITE_ASSET__BMJg2bnN__"